import './lacks-permission.component.ajscss';

import { IComponentOptions } from 'angular';

import { PermissionCtrl } from '../models/abstract-permission-ctrl';
import templateUrl from './lacks-permission.component.html';

class LacksPermissionCtrl extends PermissionCtrl {}

export class LacksPermission implements IComponentOptions {
  templateUrl = templateUrl;
  transclude = true;
  bindings = {
    name: '=',
  };
  controller = ['sessionDeprecatedService', LacksPermissionCtrl];
}

export default 'lacksPermission';
